// auto-generated by Typewriter template _models.tst from PortCall.Models\Vessels\Vessel.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';


// DeclarationOfSecurityData is the class that DeclarationOfSecurity serializes to/from
export interface DeclarationOfSecurityData {
	
	
    EffectiveDate : /* ISO8601 */ string | null;
    ExpirationDate : /* ISO8601 */ string | null;
    IssuedBy : string | null;
    ReceivedBy : string | null;
}

// DeclarationOfSecurityOptions is the class which may be passed to the DeclarationOfSecurity constructor to define optional initial data values
export interface DeclarationOfSecurityOptions {
	
	
    EffectiveDate? : /* ISO8601 */ string | null;
    ExpirationDate? : /* ISO8601 */ string | null;
    IssuedBy? : string | null;
    ReceivedBy? : string | null;
}

export class DeclarationOfSecurity {
	
	
    public EffectiveDate : DataSignal<TZDate | null>;
    public ExpirationDate : DataSignal<TZDate | null>;
    public IssuedBy : DataSignal<string | null>;
    public ReceivedBy : DataSignal<string | null>;

    constructor();
    constructor(data : DeclarationOfSecurityOptions);
    constructor(data: DeclarationOfSecurityOptions | null = null) {
	    
	    
        this.EffectiveDate = jsonableObservable(S.value<TZDate | null>(data && data.EffectiveDate !== undefined ? data.EffectiveDate === null ? null : new TZDate(data.EffectiveDate) : null, TZDate.nullableEq));
        this.ExpirationDate = jsonableObservable(S.value<TZDate | null>(data && data.ExpirationDate !== undefined ? data.ExpirationDate === null ? null : new TZDate(data.ExpirationDate) : null, TZDate.nullableEq));
        this.IssuedBy = jsonableObservable(S.value<string | null>(data && data.IssuedBy !== undefined ? data.IssuedBy : null));
        this.ReceivedBy = jsonableObservable(S.value<string | null>(data && data.ReceivedBy !== undefined ? data.ReceivedBy : null));
    }

    static key(obj : DeclarationOfSecurity) {
        return ;
    }
    
    static dataKey(obj : DeclarationOfSecurityOptions) {
        return ;
    }

    static update(obj : DeclarationOfSecurity, data : DeclarationOfSecurityOptions) {
        S.freeze(() => {
	        
	        
            if (data.EffectiveDate !== undefined) obj.EffectiveDate(data.EffectiveDate === null ? null : new TZDate(data.EffectiveDate));
            if (data.ExpirationDate !== undefined) obj.ExpirationDate(data.ExpirationDate === null ? null : new TZDate(data.ExpirationDate));
            if (data.IssuedBy !== undefined) obj.IssuedBy(data.IssuedBy);
            if (data.ReceivedBy !== undefined) obj.ReceivedBy(data.ReceivedBy);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/DeclarationOfSecurity.ts